import { WishlistModel } from "./@types/wishlist.model";

export const $WishlistModuleName = "wishlist";

export type TWishlistState = WishlistModel[];